'use client';

import { c as _c } from "react/compiler-runtime";
import { useWebHaptics } from 'web-haptics/react';
import { SoundIcon } from './SoundIcon';
interface SoundToggleProps {
  soundEnabled: boolean;
  onToggle: (enabled: boolean) => void;
}
export function SoundToggle(t0) {
  const $ = _c(13);
  const {
    soundEnabled,
    onToggle
  } = t0;
  const haptic = useWebHaptics();
  let t1;
  if ($[0] !== haptic || $[1] !== onToggle || $[2] !== soundEnabled) {
    t1 = () => {
      haptic.trigger("light");
      onToggle(!soundEnabled);
    };
    $[0] = haptic;
    $[1] = onToggle;
    $[2] = soundEnabled;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = soundEnabled ? "Disable sound" : "Enable sound";
  let t3;
  if ($[4] !== soundEnabled) {
    t3 = <SoundIcon soundEnabled={soundEnabled} />;
    $[4] = soundEnabled;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = soundEnabled ? "ON" : "OFF";
  let t5;
  if ($[6] !== t4) {
    t5 = <span>SOUND {t4}</span>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = <button type="button" onClick={t1} className="group flex items-center gap-2 text-xs opacity-40 transition-opacity hover:opacity-100" aria-label={t2}>{t3}{t5}</button>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}